import TransferInvitationContext from '@cohort/wallet/components/contexts/TransferInvitationContext';
import type {DigitalAssetTransferInvitationWDto} from '@cohort/wallet-schemas/ownership';
import {useContext} from 'react';

export const useTransferInvitationContext = (): DigitalAssetTransferInvitationWDto => {
  const context = useContext(TransferInvitationContext);

  if (context === null) {
    throw new Error(
      'useTransferInvitationContext must be used within a TransferInvitationContextProvider'
    );
  }
  return context;
};
